import { useEffect, useContext, useCallback } from "react";
import { Toaster } from "react-hot-toast";

import Header from "./Components/Headers";
// import Products from "./Components/ProductTypes/Products";
// import Items from "./Components/ProductTypes/Items";
import Context from "./Context";
// import Link from "./Components/Link";

import styles from "./App.module.scss";

// function to get current param from URL
function getQueryStringValue() {
  const queryParams = new URLSearchParams(window.location.search);
  const firstEntry = queryParams.entries().next();

  // Check if the query parameter exists
  if (!firstEntry.done && firstEntry.value[0]) {
    return firstEntry.value[0];
  } else {
    return null; // or handle this case as needed
  }
}

const App = () => {
  // const { linkSuccess, isItemAccess, dispatch } = useContext(Context);
  const { dispatch } = useContext(Context);

  const getInfo = useCallback(async () => {
    const response = await fetch("/api/info", { method: "POST" });
    if (!response.ok) {
      dispatch({ type: "SET_STATE", state: { backend: false } });
      return { paymentInitiation: false };
    }
    const data = await response.json();
    const paymentInitiation: boolean =
      data.products.includes("payment_initiation");
    dispatch({
      type: "SET_STATE",
      state: {
        products: data.products,
      },
    });
    return { paymentInitiation };
  }, [dispatch]);

  const generateToken = useCallback(
    async (paymentInitiation) => {
      const param = getQueryStringValue();

      const path = paymentInitiation
        ? "/api/create_link_token_for_payment"
        : `/api/create_link_token/${param ? param : ""}`;
      const response = await fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        dispatch({ type: "SET_STATE", state: { linkToken: null } });
        return;
      }
      const data = await response.json();
      if (data) {
        if (data.error != null) {
          dispatch({
            type: "SET_STATE",
            state: {
              linkToken: null,
              linkTokenError: data.error,
            },
          });
          return;
        }
        dispatch({ type: "SET_STATE", state: { linkToken: data.link_token } });
      }
      localStorage.setItem("link_token", data.link_token); //to use later for Oauth
    },
    [dispatch]
  );

  useEffect(() => {
    const init = async () => {
      const { paymentInitiation } = await getInfo(); // used to determine which path to take when generating token
      // do not generate a new token for OAuth redirect; instead
      // setLinkToken from localStorage
      if (window.location.href.includes("?oauth_state_id=")) {
        dispatch({
          type: "SET_STATE",
          state: {
            linkToken: localStorage.getItem("link_token"),
          },
        });
        return;
      }
      generateToken(paymentInitiation);
    };
    init();
  }, [dispatch, generateToken, getInfo]);

  return (
    <div className={styles.App}>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 25000,
          style: {
            marginTop: "10px",
          },
        }}
      />

      <div className={styles.container}>
        <Header />
      </div>
    </div>
  );
};

export default App;